<template>
  <div>
    <ContentHeader :material-nav="true" :show-back="false" />
    <div class="content-container">
      <ItemList @toTemplate="toTemplate" @toFavourite="toFavourite" :item-type="'printing'" />
    </div>
  </div>
</template>

<script>
import ContentHeader from '../../components/content-header'
import ItemList from './components/item-list'

export default {
  name: 'PrintingList',
  components: {
    ContentHeader,
    ItemList
  },
  data () {
    return {}
  },
  methods: {
    toTemplate () {
      this.$router.push({ name: 'printing-list-template' })
    },
    toFavourite () {
      this.$router.push({ name: 'printing-favourite' })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
